import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";

export type PointsAwardedModalProps = {
  handle: (val: string) => void;
  isLoad: boolean;
  isMunicipalityConfirmed : boolean;
}

export const PointsAwardedModal = ({
  open,
  toggle,
  closeOnClickOutside,
  handle,
  isLoad,
  isMunicipalityConfirmed,
}: ModalProp & PointsAwardedModalProps) => {
  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
        <div className="px-2 pb-4 sm:p-4">
          <div className="text-center sm:mt-3">
            <Dialog.Title
              as="h3"
              className="text-left leading-6 text-gray-900"
            >
              イベント参加者にポイントを付与します。よろしいですか？
            </Dialog.Title>
          </div>
        </div>
        <ModalFoterBox>
          <Button
            className="mx-2 mt-1 w-[132px]"
            outline
            onClick={toggle}
            children={"キャンセル"}
          />
          <Button
            className="mt-1 mr-2 w-[132px]"
            onClick={handle}
            children={"OK"}
            disabled={isLoad}
          />
        </ModalFoterBox>
      </Dialog.Panel>
    </Modal>
  );
};